<template>
  <div id="right-sidebar" class="animated" style="min-height: 1200px;z-index: 1000; top: 6rem;">
    <div class="sidebar-container">
      <div class="tab-pane">
        <div class="sidebar-title m-b-xs">
            <h3><i class="fa fa-bookmark m-r-xs text-navy m-t-md"></i>Bookmarks</h3>
        </div>
        <div>
          <div class="dd" id="nestable">
            <ol class="dd-list">
              <li class="dd-item">
                <div>
                  <div>
                    <div class="padding-v-1rem">
                      <v-select
                        :options="bookmarkOptions"
                        placeholder="Filter by tags"
                        v-model="bookmarksTagFilter"
                        multiple
                      ></v-select>
                    </div>
                    <bookmark :bookmark="bookmark" v-for="bookmark in computedBookmarks" :key="bookmark.id"></bookmark>
                  </div>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { String } from '../../mixins/helperMixin'
import Bookmark from './Bookmarks/Bookmark.vue'

export default {
  name: 'SavedData',
  data () {
    return {
      id: 1,
      type: '',
      mutations: [],
      bookmarksTagFilter: null,
      bookmarkOptions: [],
      editTagsDisplayed: false,
      editTagsDisplayedObj: {},
      editedBookmarkData: {name: '', tags: []}
    }
  },
  components: {
    bookmark: Bookmark
  },
  mixins: [String],
  computed: {
    sections () {
      return this.$store.state.saved
    },
    computedBookmarks () {
      if (this.bookmarksTagFilter != null && this.bookmarksTagFilter.length > 0) {
        let filteredBookmarks = []
        this.bookmarksTagFilter.forEach(el => {
          let b = this.bookmarks.filter(b => b.tags.includes(el))
          filteredBookmarks.push(b)
        })
        return filteredBookmarks[0]
      }
      return this.bookmarks
    },
    ...mapGetters({
      user: 'getUser',
      f: 'getFilters',
      bookmarks: 'getBookmarks'
    })
  },
  watch: {
    bookmarks: function (newVal) {
      this.bookmarkOptions = [...new Set(newVal.map(b => b.tags).join(',').split(','))]
    }
  },
  mounted () {
    if (this.bookmarks.length) {
      this.bookmarkOptions = [...new Set(this.bookmarks.map(b => b.tags).join(',').split(','))]
    }
  },
  methods: {
    toggleEditView (id) {
      this.editedBookmarkData.name = this.bookmarks.filter(b => b.id === id).map(b => b.name)[0]

      if (Object.keys(this.editTagsDisplayedObj).includes(id)) {
        this.editTagsDisplayedObj[id] = !this.editTagsDisplayedObj[id]
      } else {
        this.editTagsDisplayedObj[id] = true
      }
    },
    isNewNameValid () {
      return !(!this.editedBookmarkData.name.length || this.bookmarks.map(b => b.name).includes(this.editedBookmarkData.name))
    },
    async renameFilter (name, id) {
      try {
        await axios.patch(`/user/filters/${id}`, {
          name: name
        })
        await this.$store.dispatch('loadFilters')
        this.$toastr.success('Filter successfully renamed')
      } catch (e) {
        this.$toastr.error('Failed renaming filter')
      }
      console.log(`Renaming filter ${id} to ${name}`)
    },
    async deleteFilter (id, name) {
      if (confirm(`Delete filter ${name}?`)) {
        try {
          await axios.delete(`/user/filters/${id}`)
          await this.$store.dispatch('loadFilters')
          this.$toastr.success('Filter successfully deleted')
        } catch (e) {
          this.$toastr.error('Failed deleting filter')
        }
      }
    },
    async toggleGlobal (id, name, val) {
      let type = val === true ? 'global' : 'private'
      if (!confirm(`Make the filter ${type}?`)) {
        return
      }
      try {
        await axios.patch(`/user/filters/${id}`, {
          global: val
        })
        await this.$store.dispatch('loadFilters')
      } catch (e) {
        this.$toastr.error('Failed deleting filter')
      }
    }
  }
}
</script>
<style scoped>
.padding-v-1rem {
  padding: 0 1rem 0 1rem;
}
.display-none {
  display: none;
}
.display-block {
  display: block;
}
.display-inline {
  display: inline;
}
ol[dnd-list], ol[dnd-list] > li {
    position: relative;
}
.dd-list .dd-list{
  padding-left: 20px;
}
.key-title {
  text-transform: capitalize;
}
.viewData {
  position: fixed;
  top: 20px;
  right: 280px;
  width: 1024px;
  border: medium none;
  border-radius: 3px;
  -webkit-box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);
  box-shadow: 0 0 3px rgba(86, 96, 117, 0.7);
  z-index: 1100;
  background: white;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/RightSidebar.vue